export const MAX_SELECTABLE_CATEGORIES = 2;
